import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getAllocatedUserImageInfo } from "../../services/userService";
import { imageIdGenerate } from "../../utils/custom";
import { userRole } from "../../utils/constants";

function ChartUsers(props) {
  const { data } = props;

  const [allocatedUserDetails, setAllocatedUserDetails] = useState({});
  const showCoderList = data.hasOwnProperty("Coder");
  const showAuditorList = data.hasOwnProperty("Auditor");

  async function getUserDetails() {
    if(data.UserId){
      const allocatedUserData = await getAllocatedUserImageInfo(data.UserId);
      setAllocatedUserDetails(allocatedUserData);
    }
  }

  useEffect(() => {
    getUserDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.UserId]);

  return (
    <>
      <div className="col-12">
        <div className="card card-flush">
          <div className="card-header py-4 minimize">
            <p className="card-title align-items-start flex-column">
              <span className="fw-bold h4">Users</span>
            </p>
            <div className="card-toolbar mt-0">
              <button className="btn btn-icon btn-sm btn-light-primary justify-content-center minimize">
                <i className="fas fa-minus" />
              </button>
            </div>
          </div>
          {allocatedUserDetails?.data?.id && (
            <div className="card-body pt-0">
              <div className="d-flex flex-stack py-2" key={data.UserId}>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-45px symbol-circle">
                    {data?.UserRole !== userRole.TL ? (
                      <img
                        alt="Pic"
                        src={
                          allocatedUserDetails?.data?.image_url ??
                          `../assets/media/avatars/300-${imageIdGenerate(
                            allocatedUserDetails?.data?.id ?? "4",
                          )}.jpg`
                        }
                      />
                    ) : (
                      <img
                        style={{ marginLeft: "0.9rem" }}
                        alt="Pic"
                        src={
                          allocatedUserDetails?.data?.image_url ??
                          `../assets/media/avatars/300-${imageIdGenerate(
                            allocatedUserDetails?.data?.id ?? "4",
                          )}.jpg`
                        }
                      />
                    )}
                    <p className="mt-1">
                      <span className="badge bg-light text-muted">
                        {data.UserRole}
                      </span>
                    </p>
                  </div>
                  <div className="ms-5">
                    <Link
                      to=""
                      className="fs-5 fw-bold text-gray-900 text-hover-primary mb-2"
                    >
                      {`${data?.UserFirstName} ${data?.UserLastName}`}
                    </Link>
                    <div className="fw-semibold text-muted">
                      Current Allocation
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="separator separator-dashed my-3"
                style={{ backgroundColor: "white" }}
              />

              {showCoderList &&
                data?.coders?.map((item, index) => (
                  <div className="d-flex flex-stack py-2" key={index}>
                    <div className="d-flex align-items-center">
                      <div className="symbol symbol-45px symbol-circle">
                        {item?.role !== userRole.TL ? (
                          <img
                            alt="Pic"
                            src={
                              item?.image_url ??
                              `../assets/media/avatars/300-${imageIdGenerate(
                                item?.id ?? "4",
                              )}.jpg`
                            }
                          />
                        ) : (
                          <img
                            style={{ marginLeft: "0.9rem" }}
                            alt="Pic"
                            src={
                              item?.image_url ??
                              `../assets/media/avatars/300-${imageIdGenerate(
                                item?.id ?? "4",
                              )}.jpg`
                            }
                          />
                        )}
                        <p className="mt-1">
                          <span className="badge bg-light text-muted">
                            {item?.role}
                          </span>
                        </p>
                      </div>
                      <div className="ms-5">
                        <Link
                          to=""
                          className="fs-5 fw-bold text-gray-900 text-hover-primary mb-2"
                        >
                          {item?.name}
                        </Link>
                        <div className="fw-semibold text-muted">
                          {item?.role_sequence}
                        </div>
                      </div>
                    </div>
                    <div className="d-flex flex-column align-items-end ms-2">
                      <p className="mb-0 fs-3">{item?.date ?? ""}</p>
                      <span className="text-muted fs-7 mb-1">
                        Date of Coding
                      </span>
                    </div>
                  </div>
                ))}
              {data.hasOwnProperty("Coder") && (
                <div
                  className="separator separator-dashed my-3"
                  style={{ backgroundColor: "white" }}
                />
              )}

              {showAuditorList &&
                data?.auditors?.map((item, index) => (
                  <div className="d-flex flex-stack py-2" key={index}>
                    <div className="d-flex align-items-center">
                      <div className="symbol symbol-45px symbol-circle">
                        {item?.role !== userRole.TL ? (
                          <img
                            alt="Pic"
                            src={
                              item.image_url ??
                              `../assets/media/avatars/300-${imageIdGenerate(
                                item?.id ?? "1",
                              )}.jpg`
                            }
                          />
                        ) : (
                          <img
                            style={{ marginLeft: "0.9rem" }}
                            alt="Pic"
                            src={
                              item.image_url ??
                              `../assets/media/avatars/300-${imageIdGenerate(
                                item?.id ?? "1",
                              )}.jpg`
                            }
                          />
                        )}
                        <p className="mt-1">
                          <span className="badge bg-light text-muted">
                            {item?.role}
                          </span>
                        </p>
                      </div>
                      <div className="ms-5">
                        <Link
                          to=""
                          className="fs-5 fw-bold text-gray-900 text-hover-primary mb-2"
                        >
                          {item?.name}
                        </Link>
                        <div className="fw-semibold text-muted">
                          {item?.role_sequence}
                        </div>
                      </div>
                    </div>
                    <div className="d-flex flex-column align-items-end ms-2">
                      <p className="mb-0 fs-3">{item?.date ?? ""}</p>
                      <span className="text-muted fs-7 mb-1">
                        Date of Auditing
                      </span>
                    </div>
                  </div>
                ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
export default ChartUsers;
